import React from 'react';
import GeneratorBase from './GeneratorBase';
import { usePostingTime } from '../hooks/usePostingTime';

const FestivalWishesGenerator = () => {
  const postingTimeSummary = usePostingTime();

  const fields = [
    {
      name: 'festivalName',
      label: 'Festival Name',
      type: 'text',
      placeholder: 'e.g., Diwali, Holi, Republic Day, Christmas',
      required: true
    },
    {
      name: 'style',
      label: 'Style',
      type: 'select',
      options: [
        { value: 'short', label: 'Short (2-3 sentences)' },
        { value: 'medium', label: 'Medium (4-6 sentences)' },
        { value: 'long', label: 'Long (7-10 sentences)' }
      ],
      required: true
    },
    {
      name: 'tone',
      label: 'Tone',
      type: 'select',
      options: [
        { value: 'warm', label: 'Warm' },
        { value: 'professional', label: 'Professional' },
        { value: 'casual', label: 'Casual' },
        { value: 'formal', label: 'Formal' }
      ],
      required: true
    }
  ];

  return (
    <GeneratorBase
      title="Festival Wishes Generator"
      description="Create beautiful festival wishes for social media. Perfect for Diwali, Holi, Republic Day, and other celebrations. Ready to post on LinkedIn and Instagram."
      fields={fields}
      apiEndpoint="festival-wishes"
      saveDraftEndpoint="festival-wishes"
      enableLinkedIn={true}
      postingTimeSummary={postingTimeSummary}
    />
  );
};

export default FestivalWishesGenerator;
